import React from 'react';
import styled from 'styled-components';

import docxIcon from '../../../assets/img/icons/docx.png';
import pdfIcon from '../../../assets/img/icons/pdf.png';
import { COLORS } from '../../../assets/js/constants';
import { FONTS } from '../../../tokens/fonts';

const TextBlock = styled.div`
    flex-direction: column;
    justify-content: space-between;
`;

const DocumentIcon = styled.img`
  width: 25px;
  height: 32px;
  margin-right: 10px;
`;

const DocumentHref = styled.a`
  ${FONTS.MediumS};
`;

const DocumentFormat = styled.div`
  ${FONTS.XS};
  color: ${COLORS.grey};
`;

const DocumentBlock = styled.div`
    flex-wrap: nowrap;
`;

const icons = {
    'pdf': pdfIcon,
    'word': docxIcon,
};

const DocumentLink = ({ file }) => {
    return (
        <DocumentBlock>
            { icons[file.iconType] && <DocumentIcon src={icons[file.iconType]} alt={file.iconType}/> }
            <TextBlock>
                <DocumentHref
                    href={file.file}
                    rel='noopener noreferrer nofollow'
                    target='_blank'
                >
                    {file.title}
                </DocumentHref>
                <DocumentFormat>{file.iconType}</DocumentFormat>
            </TextBlock>
        </DocumentBlock>
    );
};

export default DocumentLink;
